export const clinicList = [
  {
    area: '基隆市 / 中正區',
    clinics: [
      {
        "name": "新雅牙醫診所",
        "address": "基隆市中正區祥豐街１１號",
        "telephone": "02-24620128",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "廖國棟皮膚科診所",
        "address": "基隆市中正區義一路６６號",
        "telephone": "02-24291166",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陳字斌中醫診所",
        "address": "基隆市中正區義二路１３３號",
        "telephone": "02-24283080",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/02/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "佳暉牙醫診所",
        "address": "基隆市中正區祥豐街１００號",
        "telephone": "02-24622891",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "禾新藥局",
        "address": "基隆市中正區新豐街２０５巷７號",
        "telephone": "02-24698940",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "林承興診所",
        "address": "基隆市中正區北寧路３１９號",
        "telephone": "02-24694199",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "急診請事先電話聯繫",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "躍獅大藥局",
        "address": "基隆市中正區新豐街２６３號",
        "telephone": "02-24699723",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": "營業時間12時-21時周一公休",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "俊德藥局",
        "address": "基隆市中正區中船路２０號１樓",
        "telephone": "02-24281398",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/08",
          "srv_Memo": "上午8點開始販售實名制快篩，慢性處方箋9:00~21:00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "維元社區藥局",
        "address": "基隆市中正區新豐街４４８號",
        "telephone": "02-24601388",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "譚景文婦產科診所",
        "address": "基隆市中正區義二路８７號１樓",
        "telephone": "02-24242688",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "吳婦產科診所",
        "address": "基隆市中正區義一路２３號１－２樓",
        "telephone": "02-24269000",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/10",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "勝斌牙醫診所",
        "address": "基隆市中正區八斗街１號",
        "telephone": "02-24691338",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陳怡穎皮膚科診所",
        "address": "基隆市中正區義二路６５-１號１樓",
        "telephone": "02-24276789",
        "map": null,
        "serviceInfo": {
          "srv_Date": "112/12/09",
          "srv_Memo": "週六看診時段8:30~13:30",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆市中正區衛生所",
        "address": "基隆市中正區中正路２３６號２樓",
        "telephone": "02-24621632",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": "實名制口罩已於110/7/1停止販售",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "立康復健科診所",
        "address": "基隆市中正區義二路６２號１-３樓",
        "telephone": "02-24276112",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/02",
          "srv_Memo": "113年5月，週二週四晚上無復健",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "邵秉家中醫診所",
        "address": "基隆市中正區義一路１５號１樓",
        "telephone": "02-24277296",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "孫眼科診所",
        "address": "基隆市中正區義二路５７號",
        "telephone": "02-24236019",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "2/6-2/14休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "新昆明醫院",
        "address": "基隆市中正區中正路３０號",
        "telephone": "02-24268106",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "地區醫院"
      },
      {
        "name": "瑞光眼科診所",
        "address": "基隆市中正區義一路６４號",
        "telephone": "02-24245909",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "博群診所",
        "address": "基隆市中正區新豐街４４６號",
        "telephone": "02-24601356",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/23",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "漾診所",
        "address": "基隆市中正區義一路５１號（１－３Ｆ）、５３號（１－３Ｆ）",
        "telephone": "02-24268898",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/07",
          "srv_Memo": "國定假日休診",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "鼎泰牙醫診所",
        "address": "基隆市安樂區基金一路２０２號１樓",
        "telephone": "02-34012999",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "新光牙醫診所",
        "address": "基隆市中正區義二路１６４號之１、正義路２９巷１１號之４",
        "telephone": "02-24292205",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "開山診所",
        "address": "基隆市中正區義一路２９號２樓",
        "telephone": "02-24236565",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陳耳鼻喉科診所",
        "address": "基隆市中正區信一路１６４號",
        "telephone": "02-24248881",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/23",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "蘇牙醫診所",
        "address": "基隆市中正區中正路２１５號",
        "telephone": "02-24626886",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "每月的第三週禮拜三看診，禮拜四休診。每周六下午晚上、周日全天、國定假日休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "永好藥局",
        "address": "基隆市中正區北寧路３１５號１樓",
        "telephone": "02-24697639",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/26",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "醫療財團法人臺灣區煤礦業基金會礦工基隆診所",
        "address": "基隆市中正區義一路７６號３、４樓",
        "telephone": "02-24220506",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/09",
          "srv_Memo": "6／8日上午看診.6／9，6／10日放假.",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "安瀾診所",
        "address": "基隆市中正區中正路１９７號(１Ｆ)",
        "telephone": "02-24623389",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "黃勉倉醫師骨科診所",
        "address": "基隆市中正區義一路６０號(１－２F)",
        "telephone": "02-24277729",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "藝美牙醫診所",
        "address": "基隆市中正區義一路２７號１－２樓",
        "telephone": "02-24251686",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "澄星牙醫診所",
        "address": "基隆市中正區新豐街４２８號１、２樓",
        "telephone": "02-24601333",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "朱僑光婦幼專科診所",
        "address": "基隆市中正區義一路５４號１、２、３、５、６、７樓",
        "telephone": "02-24234203",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/27",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "安大心身心診所",
        "address": "基隆市中正區新豐街２２９號１樓（不含停車空間）",
        "telephone": "02-24694100",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "八斗子診所",
        "address": "基隆市中正區北寧路３７８之１號(２F)",
        "telephone": "02-24698789",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "新豐牙醫診所",
        "address": "基隆市中正區新豐街３２３巷１９號",
        "telephone": "02-24690701",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "孫邦松兒內科診所",
        "address": "基隆市中正區信二路３１７號１樓",
        "telephone": "02-24223557",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/23",
          "srv_Memo": "2／28上午看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "喬復健科診所",
        "address": "基隆市中正區信三路８號Ｂ１樓、地面層１-３樓",
        "telephone": "02-24275228",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/23",
          "srv_Memo": "2／28 上午及下午看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "天工牙醫診所",
        "address": "基隆市中正區新豐街２５１巷６弄１４號",
        "telephone": "02-24692801",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "慈恩中醫診所",
        "address": "基隆市中正區新豐街５０６號",
        "telephone": "02-24601880",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "1每週四上午固定休診半天2端午節休息一天",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "兒童中心診所",
        "address": "基隆市中正區義一路４６號",
        "telephone": "02-24212577",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "雙鶴藥局",
        "address": "基隆市中正區義一路３５號１樓",
        "telephone": "02-24263193",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": "平日下午14:00開始販售，星期六08:30-17:30開始販售",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "忠生中醫診所",
        "address": "基隆市中正區義二路１４２號１樓",
        "telephone": "02-24259972",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "資生堂牙醫診所",
        "address": "基隆市中正區義二路８４號１樓",
        "telephone": "02-24260800",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": "預約制，初診可電話預約",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "喬寶藥局",
        "address": "基隆市中正區義二路６６號１樓",
        "telephone": "02-24202827",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "明和中醫診所",
        "address": "基隆市中正區義一路９０號",
        "telephone": "02-24270836",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "晉安診所",
        "address": "基隆市中正區義一路３９號１、２樓",
        "telephone": "02-24268178",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "八斗子東亞藥局",
        "address": "基隆市中正區北寧路３７８號",
        "telephone": "02-24698829",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "上午10點鐘開始販售「實名制快篩」，售完為止",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "海大藥局",
        "address": "基隆市中正區新豐街２５５號１樓",
        "telephone": "02-24699222",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/12",
          "srv_Memo": "平日：8：30~12：00，15：00~21：30；星期日：~12：00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "源昌藥局",
        "address": "基隆市中正區北寧路３８４號１樓",
        "telephone": "02-24691686",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "王孫斌婦產科診所",
        "address": "基隆市中正區義一路６９號１－５樓",
        "telephone": "02-24248125",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "24小時正常生產",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "承泰藥局",
        "address": "基隆市中正區新豐街４４２號",
        "telephone": "02-24601316",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "安仁心藥局",
        "address": "基隆市中正區新豐街２２９號",
        "telephone": "02-24694100",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/23",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "基隆常春藤居家護理所",
        "address": "基隆市中正區新豐街２３３號２樓",
        "telephone": "02-24620568",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "居家照護"
      },
      {
        "name": "中台醫事檢驗所",
        "address": "基隆市中正區義一路５０號",
        "telephone": "02-24247229",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/27",
          "srv_Memo": "營業時間：早上8點至晚上6點，週日休息",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "醫事檢驗機構"
      },
      {
        "name": "葛萊美診所",
        "address": "基隆市中正區義一路２３號３樓",
        "telephone": "02-24272777",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "春節連續假期期間國定假日當天均休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "張浩緯中醫診所",
        "address": "基隆市中正區義二路８９號（１Ｆ）",
        "telephone": "02-24265333",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "早上10:00至12:00.下午14:00至18:00.晚上19:00至21:30..星期六.日全日休息..星期四早上休息...........",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "文昕診所",
        "address": "基隆市中正區信四路４號、４－１號",
        "telephone": "02-24269977",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/29",
          "srv_Memo": "國定假日未休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "義一啄木鳥藥局",
        "address": "基隆市中正區義一路１１１號１、２樓",
        "telephone": "02-24271456",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/02",
          "srv_Memo": "國定假日無調劑服務",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "禎宸藥局",
        "address": "基隆市中正區中正路１７５號１樓",
        "telephone": "02-24620366",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "維德醫療社團法人基隆維德醫院",
        "address": "基隆市中正區調和街２１０號",
        "telephone": "02-24696688",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "地區醫院"
      },
      {
        "name": "全恩親子眼科診所",
        "address": "基隆市中正區新豐街２５１巷４弄１號、３號、５號",
        "telephone": "02-24696808",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "馬德里診所",
        "address": "基隆市中正區新豐街４５０號１、２樓",
        "telephone": "02-24603368",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "113／2／18 周日補上上午半天",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "合成診所",
        "address": "基隆市中正區祥豐街２０５號",
        "telephone": "02-24632532",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "112／12／30及113／01／01上午有門診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "王立文婦產科診所",
        "address": "基隆市中正區義一路４１號１、２、３、５、６、７樓",
        "telephone": "02-24278888",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": "12／30 全天看診，12／31 休診， 1／1，早上看診，下午晚上休診， 1／2 全天門診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "祥豐牙醫診所",
        "address": "基隆市中正區祥豐街１２１號２樓",
        "telephone": "02-24620599",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/14",
          "srv_Memo": "113年4月16日~113年5月15日，因醫師出國 休診.5月16日，開始看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "禾豐１０１診所",
        "address": "基隆市中正區新豐街２５７號",
        "telephone": "02-24697101",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "達美牙醫診所",
        "address": "基隆市中正區義二路８３號２樓",
        "telephone": "02-24236316",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/25",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "信光眼科診所",
        "address": "基隆市中正區信一路１６２號（１－２F）",
        "telephone": "02-24263616",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "謝牙醫診所",
        "address": "基隆市中正區義二路６６號２樓",
        "telephone": "02-24239289",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": "敝診所採約診制.國訂假日 週一  週六休診.其他日有約診才看診.",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "河南眼科診所",
        "address": "基隆市中正區義一路１３號",
        "telephone": "02-24274300",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/30",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "協和中醫診所",
        "address": "基隆市中正區義二路１７９巷２４號",
        "telephone": "02-24251810",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "傅耳鼻喉科診所",
        "address": "基隆市中正區義一路３３號１樓",
        "telephone": "02-24284955",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "112／12／31",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "和平大藥局",
        "address": "基隆市中正區中正路７５０號",
        "telephone": "02-24628151",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "天仁中醫診所",
        "address": "基隆市中正區信一路１５９巷６號１樓",
        "telephone": "02-24232055",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "艾美藥局",
        "address": "基隆市中正區義二路６５－１號１樓",
        "telephone": "02-24282609",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "已無販賣口罩",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "家康大藥局",
        "address": "基隆市中正區義一路７２號１樓",
        "telephone": "02-24212412",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "天康新豐藥局",
        "address": "基隆市中正區新豐街２５１巷４弄９號１樓",
        "telephone": "02-24695168",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/10",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "文裕藥局",
        "address": "基隆市中正區八斗街１０號",
        "telephone": "02-24691239",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "星期一至星期六早上8:30開始營業",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "百福義一藥師藥局",
        "address": "基隆市中正區義一路４８號１樓",
        "telephone": "02-24268288",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "豐年藥局",
        "address": "基隆市中正區正豐街４２號１樓",
        "telephone": "02-24631098",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "百福新豐活力藥局",
        "address": "基隆市中正區新豐街４０５號",
        "telephone": "02-24699990",
        "map": null,
        "serviceInfo": {
          "srv_Date": "112/12/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "中正藥局",
        "address": "基隆市中正區新豐街３８５號１、２樓",
        "telephone": "02-246906600",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "陳如儀兒科診所",
        "address": "基隆市中正區義一路６２號１樓",
        "telephone": "02-24259958",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "台灣國際造船股份有限公司基隆廠診療所",
        "address": "基隆市中正區和一路２２４號",
        "telephone": "02-24631021",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": "春節連續假期期間均未提供看診服務",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "彗恩診所",
        "address": "基隆市中正區義二路１２５號１樓",
        "telephone": "02-24289337",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "仁人診所",
        "address": "基隆市中正區中正路７４８─１號",
        "telephone": "02-24622294",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      }
    ],
  },
  {
    area: '基隆市 / 七堵區',
    clinics: [
      {
        "name": "廣濟堂中醫診所",
        "address": "基隆市七堵區南興路９３號１樓",
        "telephone": "02-24551615",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "立仁牙醫診所",
        "address": "基隆市七堵區開元路７１號",
        "telephone": "02-24569558",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "廖內兒科診所",
        "address": "基隆市七堵區南興路１０１號",
        "telephone": "02-24564621",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "阿蔓中醫診所",
        "address": "基隆市七堵區崇智街１０號",
        "telephone": "02-24566859",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "鈺峰中醫診所",
        "address": "基隆市七堵區百三街１０６號（１F）",
        "telephone": "02-24529191",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "每週四下午5；30",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "永生牙醫診所",
        "address": "基隆市七堵區南興路６６－５號",
        "telephone": "02-24562425",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/12",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "華仁牙醫診所",
        "address": "基隆市七堵區百三街５２號",
        "telephone": "02-24515918",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "百安居家護理所",
        "address": "基隆市七堵區百六街１２３號",
        "telephone": "02-24515085",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/27",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "居家照護"
      },
      {
        "name": "正光診所",
        "address": "基隆市七堵區南興路１２號１樓",
        "telephone": "02-24569275",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": "國定假日門診8:00-12:00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "杏福診所",
        "address": "基隆市七堵區福二街３２０號",
        "telephone": "02-24528089",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "百福牙醫診所",
        "address": "基隆市七堵區福二街２４２巷２號",
        "telephone": "02-24514436",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "112年1月21日~112年1月26日春節連假休診6天",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "鈺筌中醫診所",
        "address": "基隆市七堵區福二街２７號（１Ｆ）",
        "telephone": "02-24529595",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "健福診所",
        "address": "基隆市七堵區百五街２號",
        "telephone": "02-24515863",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/02/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "雅登藥局",
        "address": "基隆市七堵區福二街２００號",
        "telephone": "02-24513213",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/10",
          "srv_Memo": "無實名制快篩",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "惠安復健科診所",
        "address": "基隆市七堵區南興路１０號、１２號",
        "telephone": "02-24569908",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "涵悅顯微牙醫診所",
        "address": "基隆市七堵區明德一路１８６號２樓",
        "telephone": "02-24566288",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "合康藥局",
        "address": "基隆市七堵區開元路８５號１樓",
        "telephone": "02-24555173",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/14",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "濟德中醫診所",
        "address": "基隆市七堵區崇禮街８號",
        "telephone": "02-24558861",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "紀醫師診所",
        "address": "基隆市七堵區開元路８３號",
        "telephone": "02-24554195",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/27",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陳章文耳鼻喉科診所",
        "address": "基隆市七堵區明德一路１９０號",
        "telephone": "02-24569772",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/15",
          "srv_Memo": "4／1-4／7休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "涵悅美學牙醫診所",
        "address": "基隆市七堵區百三街９０號１樓",
        "telephone": "02-24529977",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "佳緣中醫診所",
        "address": "基隆市七堵區明德一路６１號",
        "telephone": "02-24568827",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆市七堵區衛生所",
        "address": "基隆市七堵區光明路２１號１樓之１、２樓",
        "telephone": "02-24562008",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": "依中央指中心函可，110年7/1日起七堵衛生所不販售實名制口罩",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "群健診所",
        "address": "基隆市七堵區開元路５９之１號地面１、３樓",
        "telephone": "02-24568190",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/13",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "維康牙醫診所",
        "address": "基隆市七堵區明德一路７５號",
        "telephone": "02-24553523",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "星期六隔週休",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "蓁禾中醫診所",
        "address": "基隆市七堵區福一街１２７號",
        "telephone": "02-24523998",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "萬福牙醫診所",
        "address": "基隆市七堵區百六街２７號",
        "telephone": "02-24517878",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "祐福診所",
        "address": "基隆市七堵區福二街１５１號",
        "telephone": "02-24523456",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "西華診所",
        "address": "基隆市七堵區百三街２９號",
        "telephone": "02-24512942",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "合豐藥局",
        "address": "基隆市七堵區明德一路１７３號",
        "telephone": "02-24561378",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "百福專業藥師藥局",
        "address": "基隆市七堵區自治街１３號１樓",
        "telephone": "02-24556688",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "泰安內科診所",
        "address": "基隆市七堵區明德一路９３號１－２樓",
        "telephone": "02-24552305",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "固定休周日，其餘全年無休。",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "尊悅牙醫診所",
        "address": "基隆市七堵區實踐路２０２號１樓及２０６號１樓",
        "telephone": "02-24526000",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "七堵杞子中醫診所",
        "address": "基隆市七堵區南興路１１２號１樓",
        "telephone": "02-24561196",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "鴻辰藥局",
        "address": "基隆市七堵區百三街４２號",
        "telephone": "02-24514485",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "藥局庫存是採取發號碼牌 庫存已經被預約 4/9起現場購買 賣完為止 取消號碼牌制度",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "康蘋藥局",
        "address": "基隆市七堵區開元路５９－２號２樓",
        "telephone": "02-24558150",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "民安藥局",
        "address": "基隆市七堵區百五街４號",
        "telephone": "02-24514938",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/14",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "正心藥局",
        "address": "基隆市七堵區南興路１０號１樓",
        "telephone": "02-24563378",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/12",
          "srv_Memo": "每日限量78盒， 星期一~六下午13:30-17:30販賣，星期日上午9:00-12:00販賣",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "泰安健保藥局",
        "address": "基隆市七堵區泰安路２１之２號",
        "telephone": "02-24525618",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/11",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "和睦家診所",
        "address": "基隆市七堵區福二街１９８號１樓",
        "telephone": "02-24523721",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/02/29",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "北安藥局",
        "address": "基隆市七堵區福二街１３５號",
        "telephone": "02-24514008",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "長樂藥局",
        "address": "基隆市七堵區明德一路１５４號",
        "telephone": "02-24554488",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/12",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "全安診所",
        "address": "基隆市七堵區明德一路１５０號１樓",
        "telephone": "02-24554997",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/27",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "宏大牙醫診所",
        "address": "基隆市七堵區福二街９１號１樓",
        "telephone": "02-24527345",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "永全牙醫診所",
        "address": "基隆市七堵區明德一路１３４號",
        "telephone": "02-24563856",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/01",
          "srv_Memo": "晚上時段18:00開始",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "佑仁聯合診所",
        "address": "基隆市七堵區開元路５９－１號、地下室１樓、１樓",
        "telephone": "02-24562212",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "康博診所",
        "address": "基隆市七堵區南興路９９號（１-２F）",
        "telephone": "02-24568800",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/29",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "慈靉中醫診所",
        "address": "基隆市七堵區光明路１９號１－２樓",
        "telephone": "02-24568770",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "康寧眼科診所",
        "address": "基隆市七堵區明德一路１７９號２樓",
        "telephone": "02-24568418",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "晶采美學牙醫診所",
        "address": "基隆市七堵區光明路５號１樓、７號１樓",
        "telephone": "02-24562456",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "福恬藥局",
        "address": "基隆市七堵區福二街１５１號１樓",
        "telephone": "02-24527766",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      }
    ],
  },
  {
    area: '基隆市 / 暖暖區',
    clinics: [
      {
        "name": "醫療財團法人臺灣區煤礦業基金會臺灣礦工醫院",
        "address": "基隆市暖暖區源遠路２９號",
        "telephone": "02-24579101",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": "急診"
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "地區醫院"
      },
      {
        "name": "佛生中醫診所",
        "address": "基隆市暖暖區暖暖街８９號１樓",
        "telephone": "02-24586006",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "東方藥局",
        "address": "基隆市暖暖區暖暖街１５３號１樓",
        "telephone": "02-24574171",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "上午8時30分販售",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "微風牙醫診所",
        "address": "基隆市暖暖區暖暖街５７２號１樓、５７６號１樓",
        "telephone": "02-24593383",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "婁診所",
        "address": "基隆市暖暖區暖暖街１７１號",
        "telephone": "02-24584498",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/05",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "華碇中醫診所",
        "address": "基隆市暖暖區源遠路２２３號",
        "telephone": "02-24591541",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "看診時間 : 下午2點至晚上9點",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "家宏藥局",
        "address": "基隆市暖暖區源遠路２８１之２號１樓",
        "telephone": "02-24595982",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "端午節休6／8~6／10三天",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "福安藥局",
        "address": "基隆市暖暖區暖暖街５５２號",
        "telephone": "02-24588550",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "週日公休",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "醫療財團法人臺灣區煤礦業基金會附設八堵居家護理",
        "address": "基隆市暖暖區源遠路２９號",
        "telephone": "02-24579101",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "居家照護"
      },
      {
        "name": "宏展藥局",
        "address": "基隆市暖暖區源遠路２７９號",
        "telephone": "02-24593311",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "杏福藥局",
        "address": "基隆市暖暖區暖暖街１７８號",
        "telephone": "02-24572427",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "源遠牙醫診所",
        "address": "基隆市暖暖區源遠路３１５號",
        "telephone": "02-24595777",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "康合診所",
        "address": "基隆市暖暖區源遠路２８１－１號",
        "telephone": "02-24592200",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "百福暖暖專業藥局",
        "address": "基隆市暖暖區暖暖街１８９號１樓",
        "telephone": "02-24596999",
        "map": null,
        "serviceInfo": {
          "srv_Date": "112/12/11",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "青森健保藥局",
        "address": "基隆市暖暖區暖暖街２３０號１樓",
        "telephone": "02-24580155",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/29",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "鴻海診所",
        "address": "基隆市暖暖區源遠路１７０號",
        "telephone": "02-24587766",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "欣華藥局",
        "address": "基隆市暖暖區源遠路１９７號",
        "telephone": "02-24576741",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "10",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "碇內東亞藥師藥局",
        "address": "基隆市暖暖區源遠路３１９號１樓",
        "telephone": "02-24590033",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "周一至周六下午三點發放快篩試劑",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "百會診所",
        "address": "基隆市暖暖區暖暖街２４６巷１６５號１樓",
        "telephone": "02-24596677",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/27",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陸記藥局",
        "address": "基隆市暖暖區源遠路２４１號",
        "telephone": "02-24576712",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/10",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "安安藥局",
        "address": "基隆市暖暖區源遠路１６８號",
        "telephone": "02-24585577",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "每週六公休",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "碇內診所",
        "address": "基隆市暖暖區源遠路３２３號",
        "telephone": "02-24595878",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": "6／10上午看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆市暖暖區衛生所",
        "address": "基隆市暖暖區暖暖街２８１巷９８號",
        "telephone": "02-24572630",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "永安牙醫診所",
        "address": "基隆市暖暖區源遠路２０１號",
        "telephone": "02-24577694",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "潔安牙醫",
        "address": "基隆市暖暖區暖暖街１５７號１樓",
        "telephone": "02-24575738",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "青森牙醫診所",
        "address": "基隆市暖暖區暖暖街２２０之１號",
        "telephone": "02-24580808",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "長春牙醫診所",
        "address": "基隆市暖暖區源遠路２２７號",
        "telephone": "02-24576083",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "109年10月5日至10月30日休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "柏林藥局",
        "address": "基隆市暖暖區暖暖街２４６巷１６７號１樓",
        "telephone": "02-24592277",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "柏悅牙醫診所",
        "address": "基隆市暖暖區源遠路１６５－２號１樓",
        "telephone": "02-24585526",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      }
    ]
  },
  {
    area: '基隆市 / 仁愛區',
    clinics: [
      {
        "name": "一日尊榮牙醫診所",
        "address": "基隆市仁愛區仁一路２０９號１至３樓",
        "telephone": "02-24260111",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "百草堂中醫診所",
        "address": "基隆市仁愛區孝三路８１號２樓",
        "telephone": "02-24277381",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "柏齡牙醫診所",
        "address": "基隆市仁愛區孝一路５５號２樓",
        "telephone": "02-24240899",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "光華藥局",
        "address": "基隆市仁愛區成功一路１２９號１樓",
        "telephone": "02-24338703",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/11",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "謝富合中醫診所",
        "address": "基隆市仁愛區孝二路９６號１樓",
        "telephone": "02-24285565",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/09",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "楊光復健診所",
        "address": "基隆市仁愛區愛三路１２０號４、５樓",
        "telephone": "02-24292288",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/27",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "李上知中醫診所",
        "address": "基隆市信義區仁一路２５號１樓",
        "telephone": "02-24274511",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "東京藥局",
        "address": "基隆市仁愛區仁四路１５號１樓",
        "telephone": "02-24214138",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/06",
          "srv_Memo": "快篩販售時間早上九點",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "其筠牙醫診所",
        "address": "基隆市仁愛區南新街５７號",
        "telephone": "02-24237890",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "春節2/11~2/16休假",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "李金澤中醫診所",
        "address": "基隆市仁愛區愛一路２６號２樓",
        "telephone": "02-24220707",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陽明牙醫診所",
        "address": "基隆市仁愛區南榮路６９號２樓",
        "telephone": "02-24245237",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆平安診所",
        "address": "基隆市仁愛區仁二路７號",
        "telephone": "02-24260767",
        "map": null,
        "serviceInfo": {
          "srv_Date": "112/12/28",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "王俊傑耳鼻喉科診所",
        "address": "基隆市仁愛區仁二路１１７號",
        "telephone": "02-24253660",
        "map": null,
        "serviceInfo": {
          "srv_Date": "112/12/27",
          "srv_Memo": "9／17只有早診，10／10只有早診，",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "安馨居家護理機構",
        "address": "基隆市仁愛區仁一路１３３號１２樓之３",
        "telephone": "02-24655900",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "居家照護"
      },
      {
        "name": "良德堂中醫診所",
        "address": "基隆市仁愛區南榮路２９號１Ｆ，２Ｆ",
        "telephone": "02-24274987",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/06",
          "srv_Memo": "星期三下午休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆生基中醫診所",
        "address": "基隆市仁愛區劉銘傳路１－３號４樓",
        "telephone": "02-24257588",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/22",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "仁祥診所附設居家護理服務部",
        "address": "基隆市仁愛區忠ㄧ路２３號２樓",
        "telephone": "02-24227080",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "居家照護"
      },
      {
        "name": "基隆市仁愛區衛生所",
        "address": "基隆市仁愛區光一路２６號",
        "telephone": "02-24311592",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陳興達診所",
        "address": "基隆市仁愛區仁四路１９巷７號１樓",
        "telephone": "02-24256410",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "令合藥師藥局",
        "address": "基隆市仁愛區仁二路２３３號１樓及地下１樓",
        "telephone": "02-24278568",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "林小兒科診所",
        "address": "基隆市仁愛區孝二路７０號",
        "telephone": "02-24229337",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/24",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "順安藥局",
        "address": "基隆市仁愛區仁二路７２號",
        "telephone": "02-24213381",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "代售口罩及發號碼牌時間:星期一至星期六每日上午10:00~11:00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "王順水小兒科診所",
        "address": "基隆市仁愛區仁二路５６號",
        "telephone": "02-24201733",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "悅心中醫診所",
        "address": "基隆市仁愛區仁１路１７３號（１Ｆ）",
        "telephone": "02-24275722",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "聯安藥局",
        "address": "基隆市仁愛區仁二路２５１號２樓",
        "telephone": "02-24288809",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "安東耳鼻喉科二樓循環站正對面 快篩販售時間更改8:30-11:50， 假日8:30-11:00 售完為止",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "健安婦產科診所",
        "address": "基隆市仁愛區仁二路７８號",
        "telephone": "02-24244543",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/20",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "盧耳鼻喉科診所",
        "address": "基隆市仁愛區仁二路１５４號１.２Ｆ",
        "telephone": "02-24224052",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "廖曉俊診所",
        "address": "基隆市仁愛區延平街２號",
        "telephone": "02-24251525",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "2/11下午-2/15休診(內科)",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "鄭曦診所",
        "address": "基隆市仁愛區忠二路７號１-２樓",
        "telephone": "02-24260711",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/11",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "長壽牙醫診所",
        "address": "基隆市仁愛區孝一路４０號２樓",
        "telephone": "02-24291608",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "端午6/25-6/28休假",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "天康大藥局",
        "address": "基隆市仁愛區南榮路１３１號、地下１樓",
        "telephone": "02-77091122",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/10",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "林耳鼻咽喉科診所",
        "address": "基隆市仁愛區忠二路３－１４號",
        "telephone": "02-24229646",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/13",
          "srv_Memo": "滿65歲或持殘障手冊50元",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "胡耳鼻喉科診所",
        "address": "基隆市仁愛區仁五路５７號(１F)",
        "telephone": "02-24248736",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "長虹藥師藥局",
        "address": "基隆市仁愛區仁三路８８號１樓",
        "telephone": "02-24261318",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "威陽藥局",
        "address": "基隆市仁愛區孝二路６８號１樓",
        "telephone": "02-24255646",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "喜聖診所",
        "address": "基隆市仁愛區劉銘傳路１－５號６樓",
        "telephone": "02-24287378",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "資耳鼻喉科診所",
        "address": "基隆市仁愛區仁一路２６１之２號",
        "telephone": "02-24228966",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "大田大藥局",
        "address": "基隆市仁愛區仁二路５號",
        "telephone": "02-24258762",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/30",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "黃勝雄診所",
        "address": "基隆市仁愛區南榮路１１５號",
        "telephone": "02-24220470",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "正祥復健科診所",
        "address": "基隆市仁愛區仁五路８號２樓之１、２樓之２及１２號１樓",
        "telephone": "02-24281850",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/24",
          "srv_Memo": "星期六復健治療到12:00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "蔡志明牙醫診所",
        "address": "基隆市仁愛區仁二路１００號１樓",
        "telephone": "02-24239238",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "台北大鎮健康牙醫診所",
        "address": "基隆市仁愛區孝三路８７號",
        "telephone": "02-24201997",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "上久中醫診所",
        "address": "基隆市仁愛區孝二路６５號１樓",
        "telephone": "02-24254088",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/02",
          "srv_Memo": "2024年3／16~3／20 診所休診五天",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "佑昌藥局",
        "address": "基隆市仁愛區南榮路１７號",
        "telephone": "02-24293309",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "姜晴中醫診所",
        "address": "基隆市仁愛區劉銘傳路３號",
        "telephone": "02-24292168",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "長安藥師藥局",
        "address": "基隆市仁愛區劉銘傳路１０號",
        "telephone": "02-24223826",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "每日早上08:00排隊賣口罩",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "安泰牙醫診所",
        "address": "基隆市仁愛區愛三路１４號",
        "telephone": "02-24291828",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/25",
          "srv_Memo": "6／6.6／10.6／29各休診一天",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "品馨牙醫診所",
        "address": "基隆市仁愛區愛二路２９號１－２樓",
        "telephone": "02-24285100",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "113.06.10（一）端午節休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "永樂藥局",
        "address": "基隆市仁愛區忠二路２２號",
        "telephone": "02-24214878",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "恆生診所",
        "address": "基隆市仁愛區愛三路１２０號３樓",
        "telephone": "02-24292288",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "仁愛診所",
        "address": "基隆市仁愛區孝三路８０號",
        "telephone": "02-24223255",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/15",
          "srv_Memo": "端午節（6／22）只看上午時段",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "君悅牙醫診所",
        "address": "基隆市仁愛區劉銘傳路１－１號２樓",
        "telephone": "02-24262165",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "重生診所",
        "address": "基隆市仁愛區成功１路１２２號（１Ｆ）",
        "telephone": "02-24317160",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "楊耳鼻喉科診所",
        "address": "基隆市仁愛區仁二路１１５號",
        "telephone": "02-24245212",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/22",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "國泰牙醫診所",
        "address": "基隆市仁愛區仁二路９１號",
        "telephone": "02-24282866",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/08",
          "srv_Memo": "112年1月2日早.中.晚.全天看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆心身心精神科診所",
        "address": "基隆市仁愛區仁一路１８１號１樓",
        "telephone": "02-24283399",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "113／6／8（六）、113／6／10（一）端午連假正常看診",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "楨品美學牙醫診所",
        "address": "基隆市仁愛區忠二路２６號",
        "telephone": "02-24255255",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "貝陽兒童牙醫診所",
        "address": "基隆市仁愛區仁二路９５號３樓",
        "telephone": "02-24258001",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/02/27",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "佳基內科診所",
        "address": "基隆市仁愛區劉銘傳路１－７號８樓",
        "telephone": "02-24215047",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/28",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "永年牙醫診所",
        "address": "基隆市仁愛區孝三路３１號",
        "telephone": "02-24261706",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/15",
          "srv_Memo": "端午6/25-6/28休假",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "洪診所",
        "address": "基隆市仁愛區孝三路１０５號",
        "telephone": "02-24223229",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "王大夫診所",
        "address": "基隆市仁愛區南榮路４３號",
        "telephone": "02-24233769",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "東大診所",
        "address": "基隆市仁愛區忠二路４７號",
        "telephone": "02-24232992",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "滕起民牙醫診所",
        "address": "基隆市仁愛區仁三路１３號２樓、３樓",
        "telephone": "02-24291123",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "駱明德牙醫診所",
        "address": "基隆市仁愛區仁二路２０８號之１（２樓）",
        "telephone": "02-24245190",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "光華牙醫診所",
        "address": "基隆市仁愛區成功一路１１９號及１２１號１樓",
        "telephone": "02-24339461",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "成美牙醫診所",
        "address": "基隆市仁愛區仁四路１４號",
        "telephone": "02-24221123",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "全成內兒科診所",
        "address": "基隆市仁愛區仁五路８號２樓－３",
        "telephone": "02-24280977",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/02/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "趙牙醫診所",
        "address": "基隆市仁愛區愛二路６４號２樓",
        "telephone": "02-24278794",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "三軍總醫院基隆分院附設民眾診療服務處",
        "address": "基隆市中正區正榮街１００號，仁愛區孝二路３９號２樓",
        "telephone": "02-24633330",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": "急診"
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "地區醫院"
      },
      {
        "name": "安東耳鼻喉科診所",
        "address": "基隆市仁愛區仁二路２５１號１樓",
        "telephone": "02-24266766",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/14",
          "srv_Memo": "4／4全日休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "聯合中醫診所",
        "address": "基隆市仁愛區孝二路１０號",
        "telephone": "02-24282669",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/20",
          "srv_Memo": "113／06／14-113／06／18---出國休診五日",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "安生牙醫診所",
        "address": "基隆市仁愛區仁五路６號２樓",
        "telephone": "02-24235130",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": "113.06.10 端午節休假",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "林內兒科診所",
        "address": "基隆市仁愛區仁五路１１號",
        "telephone": "02-24277326",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "孫皮膚科診所",
        "address": "基隆市仁愛區愛三路１２０號３樓",
        "telephone": "02-24245050",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": "1130501勞動節 有門診 上午下午夜診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "安基診所",
        "address": "基隆市仁愛區愛五路３４號５樓",
        "telephone": "02-24272345",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "元翔診所",
        "address": "基隆市仁愛區忠二路５５號３樓",
        "telephone": "02-24216696",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "魏心臟科診所",
        "address": "基隆市仁愛區仁二路８８號",
        "telephone": "02-24233057",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "111／06／03端午節上午門診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "英哲牙醫診所",
        "address": "基隆市仁愛區愛四路７２號２樓",
        "telephone": "02-24245375",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/30",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "羅杰診所",
        "address": "基隆市仁愛區愛三路１２０號３樓",
        "telephone": "02-24292288",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "1/22早上看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "懷仁診所",
        "address": "基隆市仁愛區仁五路１０號（１F）",
        "telephone": "02-24223597",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆生基婦產科診所",
        "address": "基隆市仁愛區劉銘傳路１－３號４樓",
        "telephone": "02-24257588",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/03",
          "srv_Memo": "週日及國定假日休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "楊外骨科診所",
        "address": "基隆市仁愛區仁二路２１號１、２樓",
        "telephone": "02-24257163",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/04",
          "srv_Memo": "6／10端午下午晚上休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "仁祥診所",
        "address": "基隆市仁愛區忠一路２０號１-３樓及２３號１樓",
        "telephone": "02-24232111",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "曜聖牙醫診所",
        "address": "基隆市仁愛區仁一路２７７號２樓",
        "telephone": "02-24249391",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": "6／1 8 15 22 29  有看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "高士振診所",
        "address": "基隆市仁愛區南榮路１６－１號１、２、９樓",
        "telephone": "02-24212288",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "一元堂中醫診所",
        "address": "基隆市仁愛區成功一路１２５號",
        "telephone": "02-24338790",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "麗星美學牙醫診所",
        "address": "基隆市仁愛區仁五路１２號２樓",
        "telephone": "02-24252246",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "逍遙中醫診所",
        "address": "基隆市仁愛區忠二路５５－２號",
        "telephone": "02-24221200",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "婕登藥局",
        "address": "基隆市仁愛區愛三路５３號１、２樓",
        "telephone": "02-24222582",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "成人口罩：每天下午三點開始發放號碼牌",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "何房藥局",
        "address": "基隆市仁愛區忠三路８１號",
        "telephone": "02-24222978",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "佳冠內科診所",
        "address": "基隆市仁愛區忠一路２０號４樓",
        "telephone": "02-24251636",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "經典牙醫診所",
        "address": "基隆市仁愛區忠二路１９號１－２樓",
        "telephone": "02-24276080",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "全昱藥局",
        "address": "基隆市仁愛區仁二路１１３號",
        "telephone": "02-24241522",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "開始販售時間:9:00-12:00/15:00-18:00/19:00-21:00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "德勳中醫診所",
        "address": "基隆市仁愛區愛六路１８號",
        "telephone": "02-24261268",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "看診時間: 早:09:30-01:30午:01:30-05:30夜06:00-09:30歡迎電話預約",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "江文標皮膚科診所",
        "address": "基隆市仁愛區愛三路１２０號６樓",
        "telephone": "02-24278759",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "10/9上午.下午.晚上.三診次沒有休診照常看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "回春藥局",
        "address": "基隆市仁愛區仁五路４３號",
        "telephone": "02-24224728",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "3/9及3/10因電腦送修不賣口罩 13:00發號碼牌 16:00~18:00領口罩",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "祥新藥局",
        "address": "基隆市仁愛區忠一路３１號１樓",
        "telephone": "02-24265551",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": "13:00開始販售15:00截止。若提前售完，就提前結束。其他時間勿擾",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "藥安心基隆藥局",
        "address": "基隆市仁愛區愛一路１７巷１６號２樓",
        "telephone": "02-24278420",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "第一藥局",
        "address": "基隆市仁愛區愛三路１２０號３樓",
        "telephone": "02-24292288",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/06",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "佑聖藥局",
        "address": "基隆市仁愛區仁二路１８８號",
        "telephone": "02-24201762",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "即日起口罩販售店外公告，周日公休",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "承成牙醫診所",
        "address": "基隆市仁愛區仁一路２７７號４樓",
        "telephone": "02-24291493",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陳正時婦產科診所",
        "address": "基隆市仁愛區愛四路２巷１號",
        "telephone": "02-24223388",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "松禾診所",
        "address": "基隆市仁愛區仁一路２５９號６樓",
        "telephone": "02-24288928",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "捷登藥局",
        "address": "基隆市仁愛區孝三路９２號１樓",
        "telephone": "02-24237888",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/01",
          "srv_Memo": "國定假日有提供藥事調劑服務",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "李任堅小兒科診所",
        "address": "基隆市仁愛區孝一路８６號",
        "telephone": "02-24269096",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "5／1勞動節晚上休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "孟俊診所",
        "address": "基隆市仁愛區南榮路１２９號１樓",
        "telephone": "02-24293128",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/14",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "超群牙醫診所",
        "address": "基隆市仁愛區南榮路３號２樓",
        "telephone": "02-24234194",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      }
    ]
  },
  {
    area: '基隆市 / 中山區',
    clinics: [
      {
        "name": "林文毅婦產科診所",
        "address": "基隆市中山區安一路２７號",
        "telephone": "02-24288818",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "親親診所",
        "address": "基隆市中山區復興路１７９號",
        "telephone": "02-24374880",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "順豐藥局",
        "address": "基隆市中山區中華路４號",
        "telephone": "02-24369176",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/02",
          "srv_Memo": "家用快篩每日上午8點起隨到隨領售完為止。",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "展望牙醫診所",
        "address": "基隆市中山區安一路２號２樓",
        "telephone": "02-24234106",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": "★星期三晚上和星期四早上 休診 （★星期一、六、日 休診）",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "中山藥局",
        "address": "基隆市中山區中山二路４５號",
        "telephone": "02-24269996",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": "星期一~五中午12點賣快篩售完為止 星期六下午1點 本週日11點販賣",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "金華牙醫診所",
        "address": "基隆市中山區中山二路６５巷７號",
        "telephone": "02-24223647",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "大哈密藥局",
        "address": "基隆市中山區中山二路５號",
        "telephone": "02-24285368",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "美綠居家護理所",
        "address": "基隆市中山區中山一路１２１號５樓",
        "telephone": "02-24251665",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/27",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "居家照護"
      },
      {
        "name": "大慶診所",
        "address": "基隆市中山區復興路１４２號（１Ｆ）",
        "telephone": "02-24366999",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": "元旦.清明.端午.中秋.國慶等國定假日上午8:30~12:00看診,下午,晚上休診.",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "錦泰藥局",
        "address": "基隆市中山區中山二路４３號",
        "telephone": "02-24228523",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": "快篩販賣時間星期一至五晚上7點，星期六，星期日下午5點",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "至誠診所",
        "address": "基隆市中山區安一路３號",
        "telephone": "02-24246151",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "萬方診所",
        "address": "基隆市中山區中山二路５９號",
        "telephone": "02-24263358",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/20",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "日榮牙醫診所",
        "address": "基隆市中山區安一路６號",
        "telephone": "02-24287294",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "北大牙醫診所",
        "address": "基隆市中山區復旦路１７－４號",
        "telephone": "02-24267824",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": "採預約制",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "外木山藥局",
        "address": "基隆市中山區復興路３２８之５號",
        "telephone": "02-24373636",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/10",
          "srv_Memo": "星期一~五及星日早上8:30開始售口罩。(星期六休)",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "許牙醫診所",
        "address": "基隆市中山區西定路３６號",
        "telephone": "02-24224872",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/05",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "高登藥局",
        "address": "基隆市中山區安一路７２號",
        "telephone": "02-24270872",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "安一外科診所",
        "address": "基隆市中山區安一路７９號",
        "telephone": "02-24236262",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "百福安一藥局",
        "address": "基隆市中山區安一路８１號",
        "telephone": "02-24258068",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "大慶大藥局",
        "address": "基隆市中山區中和路１６８巷３弄２０號",
        "telephone": "02-24378640",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "林義宏診所",
        "address": "基隆市中山區復興路２６３號",
        "telephone": "02-24366481",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "6／10 上午應診，下午晚上休診。／／上午:09:00-12:00 下午:03:00-06:00 晚上:06:40-08:40",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "隆源牙醫診所",
        "address": "基隆市中山區西定路７號",
        "telephone": "02-24283858",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/23",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "瑞之盟居家呼吸照護所",
        "address": "基隆市中山區西定路３９－１號",
        "telephone": "09-37985997",
        "map": null,
        "serviceInfo": {
          "srv_Date": "112/12/27",
          "srv_Memo": "週一至週五上午9點~下午5點，緊急狀況請自行連絡院所",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "呼吸照護所"
      },
      {
        "name": "何朝榮診所",
        "address": "基隆市中山區復興路１７６號",
        "telephone": "02-24374420",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/03",
          "srv_Memo": "除夕上午看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "親親藥局",
        "address": "基隆市中山區復興路１８１號",
        "telephone": "02-24378323",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/12",
          "srv_Memo": "已停止快篩銷售",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "聖鑫藥局",
        "address": "基隆市中山區復興路１２３號",
        "telephone": "02-24378911",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "李筱隆耳鼻喉科診所",
        "address": "基隆市中山區安一路６３號",
        "telephone": "02-24254198",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "隆泰藥局",
        "address": "基隆市中山區西定路１２號",
        "telephone": "02-24225889",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "協和牙醫診所",
        "address": "基隆市中山區中華路５９號",
        "telephone": "02-24257113",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "安定診所",
        "address": "基隆市中山區安一路９０號",
        "telephone": "02-24213279",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "海悅牙醫診所",
        "address": "基隆市中山區成功二路６３號１、２樓",
        "telephone": "02-24251063",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "聖德診所",
        "address": "基隆市中山區西定路４１１號",
        "telephone": "02-24293939",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "6／8只看上午 6／9全日休診 6／10只看上午",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "中山牙醫診所",
        "address": "基隆市中山區中山一路１９號",
        "telephone": "02-24250430",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/06",
          "srv_Memo": "每診次結束前半小時停止掛號",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "李台光牙醫診所",
        "address": "基隆市中山區中和路１６８巷２弄１８號１樓",
        "telephone": "02-24377334",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/31",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "禾安牙醫診所",
        "address": "基隆市中山區西定路１５３號２樓",
        "telephone": "02-24225327",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "永安診所",
        "address": "基隆市中山區西定路２６號 (１F)",
        "telephone": "02-24259947",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "寶慷藥局",
        "address": "基隆市中山區復興路１９１號１樓",
        "telephone": "02-24362338",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "08:00開始販賣快篩",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "得美膚診所",
        "address": "基隆市中山區安一路１１號１樓",
        "telephone": "02-24231123",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/02/04",
          "srv_Memo": "有提供皮膚外傷傷口縫合換藥,急性皮膚過敏治療服務",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "仁登藥局",
        "address": "基隆市中山區復興路１２２號１樓",
        "telephone": "02-24375789",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "復興藥局",
        "address": "基隆市中山區復興路１２８、１３０、１３２、１３４號１、２樓",
        "telephone": "02-24362566",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "永吉牙醫診所",
        "address": "基隆市中山區復興路１８５號",
        "telephone": "02-24367767",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "民安診所",
        "address": "基隆市中山區中華路１１號１樓",
        "telephone": "02-24231333",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/28",
          "srv_Memo": "上午8:00-12:00， 周三及國定假日休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "宏海藥局",
        "address": "基隆市中山區復興路１４４號",
        "telephone": "02-24373933",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "安安診所",
        "address": "基隆市中山區復興路３２８之４號",
        "telephone": "02-24377799",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "明觀現代科學中醫診所",
        "address": "基隆市中山區西定路１５８號",
        "telephone": "02-24216166",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "休診時間前15分鐘即停止掛號，請各位病友留意及配合，謝謝!",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "復興診所",
        "address": "基隆市中山區復興路１２５號",
        "telephone": "02-24378911",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/26",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "德和牙醫診所",
        "address": "基隆市中山區西定路４４３號",
        "telephone": "02-24220496",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "日星藥局",
        "address": "基隆市中山區安一路２５號",
        "telephone": "02-24222090",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": "十二點開始販賣",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "仁傑小兒專科診所",
        "address": "基隆市中山區安一路４９號",
        "telephone": "02-24254123",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/06",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "允安中醫診所",
        "address": "基隆市中山區中和路１６８巷６弄１７號",
        "telephone": "02-24377030",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "同仁堂中醫診所",
        "address": "基隆市中山區西定路１１７號１樓",
        "telephone": "02-24227077",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "吉安藥局",
        "address": "基隆市中山區安一路３２號",
        "telephone": "02-24260229",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "基隆市中山區衛生所",
        "address": "基隆市中山區中山二路１５號",
        "telephone": "02-24229860",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "柏泰牙醫診所",
        "address": "基隆市中山區復興路９５－９號１－２樓",
        "telephone": "02-24371151",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      }
    ],
  },
  {
    area: '基隆市 / 安樂區',
    clinics: [
      {
        "name": "祐寧藥局",
        "address": "基隆市安樂區樂利三街１０２號",
        "telephone": "02-24321718",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "胡耿豪身心精神科診所",
        "address": "基隆市安樂區武嶺街８５號",
        "telephone": "02-24310311",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/11",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "立安牙醫診所",
        "address": "基隆市安樂區安一路１０５號",
        "telephone": "02-24250388",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/06",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "福泰藥局",
        "address": "基隆市安樂區麥金路４３３號",
        "telephone": "02-24311631",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "聖康中醫診所",
        "address": "基隆市安樂區安樂路２段９６號",
        "telephone": "02-24302899",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "為維護醫療品質.本診所採預約制.額滿即止.請提前事先預約.",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "同德中醫診所",
        "address": "基隆市安樂區基金一路１３１之２３號１樓",
        "telephone": "02-24337719",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/13",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "大武崙藥局",
        "address": "基隆市安樂區基金一路１３１之１８號",
        "telephone": "02-24343377",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "李偉華耳鼻喉科診所",
        "address": "基隆市安樂區安樂路２段１７９號",
        "telephone": "02-24348535",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/07",
          "srv_Memo": "星期六.下午.16:00-18:00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "亞德牙醫診所",
        "address": "基隆市安樂區樂利三街２巷９號",
        "telephone": "02-24311000",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/02/29",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "欣城牙醫診所",
        "address": "基隆市安樂區麥金路２３１－７號１樓",
        "telephone": "02-24335206",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "小普派小兒科診所",
        "address": "基隆市安樂區樂利三街２３９號",
        "telephone": "02-24336425",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "立登藥局",
        "address": "基隆市安樂區麥金路１９７號１樓",
        "telephone": "02-24334477",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": "藥局快篩劑代售15:00開始販售 現場排隊",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "逢安中醫診所",
        "address": "基隆市安樂區麥金路４５１號（１Ｆ）",
        "telephone": "02-24332331",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": "6／8（六）-6／10（一）連休",
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "羅森堡藥局",
        "address": "基隆市安樂區安和一街２巷２２號",
        "telephone": "02-24319869",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/14",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "夢悅美學牙醫診所",
        "address": "基隆市安樂區安樂路２段１９５號２樓",
        "telephone": "02-24310733",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/25",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "暘基醫院",
        "address": "基隆市安樂區基金一路１２９巷８號地下１、地下２及１至５樓",
        "telephone": "02-24322522",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/18",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "地區醫院"
      },
      {
        "name": "青樺藥局",
        "address": "基隆市安樂區安樂路２段１７７號１樓",
        "telephone": "02-24325410",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/06",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "李卓為診所",
        "address": "基隆市安樂區基金一路１３３－５號１樓",
        "telephone": "02-24332900",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "濟仁診所",
        "address": "基隆市安樂區基金一路１３１之１９號",
        "telephone": "02-24333416",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/16",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "濟生藥局",
        "address": "基隆市安樂區基金三路８２－２號",
        "telephone": "02-24310884",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "長庚醫療財團法人基隆長庚紀念醫院",
        "address": "基隆市安樂區麥金路２２２號、基隆市麥金路２０１號",
        "telephone": "02-24313131",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "區域醫院"
      },
      {
        "name": "基隆市安樂區衛生所",
        "address": "基隆市安樂區安樂路２段１６４號１樓前棟",
        "telephone": "02-24318061",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "百會長庚診所",
        "address": "基隆市安樂區安和一街２巷２０號１樓",
        "telephone": "02-24326660",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/11",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "馨晴牙醫診所",
        "address": "基隆市安樂區基金一路１１６－１號１－２樓",
        "telephone": "02-24312222",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "南光神經精神科醫院",
        "address": "基隆市安樂區基金一路９１號",
        "telephone": "02-24310082",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/03",
          "srv_Memo": "5／1勞動節休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "地區醫院"
      },
      {
        "name": "悅來牙醫診所",
        "address": "基隆市安樂區基金三路５２之１號、５２之２號均含１至２樓",
        "telephone": "02-24345000",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/10",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "光民牙醫診所",
        "address": "基隆市安樂區樂利三街２３５號",
        "telephone": "02-24316506",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "長春藥局",
        "address": "基隆市安樂區基金一路１７４號之２０",
        "telephone": "02-24344550",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/12",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "泓翔耳鼻喉科診所",
        "address": "基隆市安樂區基金一路２０６之２號",
        "telephone": "02-24301268",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "宏基藥局",
        "address": "基隆市安樂區武嶺街６４號１樓",
        "telephone": "02-24319498",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "長庚醫療財團法人附設基隆居家護理所",
        "address": "基隆市安樂區麥金路２２２號",
        "telephone": "02-24313131",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "居家照護"
      },
      {
        "name": "武嶺牙醫診所",
        "address": "基隆市安樂區武嶺街９５號",
        "telephone": "02-24343186",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "佑全基隆麥金藥局",
        "address": "基隆市安樂區麥金路２０１號地下１樓之１",
        "telephone": "02-24347816",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/02/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "健翔牙醫診所",
        "address": "基隆市安樂區武嶺街８９號",
        "telephone": "02-24301867",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/06",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "芸湖藥局",
        "address": "基隆市安樂區武嶺街８５之１號１樓",
        "telephone": "02-34010311",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "愛沐牙醫診所",
        "address": "基隆市安樂區基金一路１１６號１－２樓",
        "telephone": "02-24312222",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "宏仁藥局",
        "address": "基隆市安樂區安樂路２段１３０號",
        "telephone": "02-24321739",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "安信牙醫診所",
        "address": "基隆市安樂區樂利三街１２４之１號２樓",
        "telephone": "02-24300948",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "欣隆牙醫診所",
        "address": "基隆市安樂區麥金路１９７號２樓",
        "telephone": "02-24335151",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "安樂藥局",
        "address": "基隆市安樂區基金一路２００號１樓",
        "telephone": "02-24331226",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/09",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "大德診所",
        "address": "基隆市安樂區基金１路１７４之８號１樓",
        "telephone": "02-24336695",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基金藥局",
        "address": "基隆市安樂區基金一路１３３－６號１樓",
        "telephone": "02-24332953",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "國定假日8:30~12:00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "康美藥局",
        "address": "基隆市安樂區基金一路１３５巷４６號１樓",
        "telephone": "02-34012988",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "星和牙醫診所",
        "address": "基隆市安樂區安樂路２段１２２號",
        "telephone": "02-24300000",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/10",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      }
    ],
  },
  {
    area: '基隆市 / 信義區',
    clinics: [
      {
        "name": "家安藥師藥局",
        "address": "基隆市信義區信二路２５７、２５９號１樓",
        "telephone": "02-24223917",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/11",
          "srv_Memo": "星期一 ~ 星期日",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "仁心牙醫診所",
        "address": "基隆市信義區信二路９９－１號１樓",
        "telephone": "02-24235814",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "世杰中醫診所",
        "address": "基隆市信義區信一路１１４號",
        "telephone": "02-24260588",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/02",
          "srv_Memo": "8:30-11.00,17:00-20:00",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "睿聲藥局",
        "address": "基隆市信義區深溪路６４號１樓",
        "telephone": "02-24656633",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "衛生福利部基隆醫院附設居家護理",
        "address": "基隆市信義區信二路２６８號",
        "telephone": "02-24292525",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "居家照護"
      },
      {
        "name": "一品牙醫診所",
        "address": "基隆市信義區義九路１號",
        "telephone": "02-24237060",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆市立醫院附設居家護理",
        "address": "基隆市信義區東信路２８２號",
        "telephone": "02-24652141",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "居家照護"
      },
      {
        "name": "蘋果藥局",
        "address": "基隆市信義區東明路９７號",
        "telephone": "02-24685158",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "信義診所",
        "address": "基隆市信義區東信路１５號",
        "telephone": "02-24653680",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/17",
          "srv_Memo": "110/01/01早上看診 1/2早 中 午看診 1/3早上看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆藥局",
        "address": "基隆市信義區東信路１６６、１６８號１、２樓",
        "telephone": "02-24680955",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "衛生福利部基隆醫院附設社區復健中心",
        "address": "基隆市信義區信一路１２４號１樓",
        "telephone": "02-24292525",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "社區精神復健"
      },
      {
        "name": "臺大牙醫診所",
        "address": "基隆市信義區東信路３２０號１樓、２樓及３２２號１樓、２樓",
        "telephone": "02-24653000",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "心禾藥局",
        "address": "基隆市信義區信二路２８１號１樓",
        "telephone": "02-24272274",
        "map": null,
        "serviceInfo": {
          "srv_Date": "112/12/22",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "國泰家醫診所",
        "address": "基隆市信義區信一路１１５號",
        "telephone": "02-24254195",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "1／1（一）晚上休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "暘基康復之家",
        "address": "基隆市信義區深美街１７８、１８０、１８２、１８６號１樓",
        "telephone": "02-24667760",
        "map": null,
        "serviceInfo": {
          "srv_Date": null,
          "srv_Memo": null,
          "srv_Time": null
        },
        "type": "社區精神復健"
      },
      {
        "name": "新大牙醫診所",
        "address": "基隆市信義區東明路１５９─１號",
        "telephone": "02-24653846",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/31",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "金石牙醫診所",
        "address": "基隆市信義區信二路２４─３號１樓",
        "telephone": "02-24225020",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "瑞明中醫診所",
        "address": "基隆市信義區東信路１５６–１號",
        "telephone": "02-24661119",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/10",
          "srv_Memo": "國定例假日休診（彈補休除外）",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "小不點健保藥局",
        "address": "基隆市信義區深溪路１２６號１樓",
        "telephone": "02-24683985",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/11",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "御鈿牙醫診所",
        "address": "基隆市信義區信一路６３之３號１樓",
        "telephone": "02-24260163",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/07",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "信安藥局",
        "address": "基隆市信義區信二路９９號",
        "telephone": "02-24238551",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "快篩實名制-早上8點30開始販售--中午1-3點午休--",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "黃振國診所",
        "address": "基隆市信義區東信路２１８號",
        "telephone": "02-24669255",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": "除夕上午看診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "兆康牙醫診所",
        "address": "基隆市信義區東信路７８號",
        "telephone": "02-24658798",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/04",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "元登藥局",
        "address": "基隆市信義區深溪路１４９號",
        "telephone": "02-24663826",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "63",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "73",
                "urlYN": "V",
                "hospName": null
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "楊宗源牙醫診所",
        "address": "基隆市信義區東明路２２號",
        "telephone": "02-24668824",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/02",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "深美藥局",
        "address": "基隆市信義區深澳坑路１－５８號",
        "telephone": "02-24685728",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/02",
          "srv_Memo": "12:00~15:00午休。星期二只營業至中午12:00。星期六固定休息。",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "王式鴻診所",
        "address": "基隆市信義區東信路３０４號",
        "telephone": "02-24665050",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": "週六上午門診，週日休，4／4及4／5上午門診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "詠欣精神科診所",
        "address": "基隆市信義區信二路２８１號（１Ｆ）",
        "telephone": "02-24272247",
        "map": null,
        "serviceInfo": {
          "srv_Date": "112/12/22",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "金聲牙醫診所",
        "address": "基隆市信義區東信路１０５號１樓",
        "telephone": "02-24220358",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "陳醫師診所",
        "address": "基隆市信義區信一路１４１巷２０號(１F)",
        "telephone": "02-24252019",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/13",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "瀚翔骨科診所",
        "address": "基隆市信義區深溪路１９號１－３樓",
        "telephone": "02-24666063",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/15",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "東信診所",
        "address": "基隆市信義區東信路１５６號（１樓）",
        "telephone": "02-24669455",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/23",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "世家中醫診所",
        "address": "基隆市信義區義六路３號１樓",
        "telephone": "02-24250925",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/08",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "邱診所",
        "address": "基隆市信義區義七路２０號",
        "telephone": "02-24250126",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/10",
          "srv_Memo": "周一至周六上午9-12周一至周五晚上5:30-8:30看診星期六晚上休診星期日全天休診國訂假日臨時公告",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "優美牙醫診所",
        "address": "基隆市信義區東信路１８８號",
        "telephone": "02-24656636",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "德安牙醫診所",
        "address": "基隆市信義區義七路２６巷１－４號",
        "telephone": "02-24275975",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "世界診所",
        "address": "基隆市信義區深澳坑路１之５４號（１Ｆ）",
        "telephone": "02-24662266",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/28",
          "srv_Memo": "星期二只至12:00；星期六固定休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "72",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆市立醫院",
        "address": "基隆市信義區東信路２８２號，中正區義二路２巷６號",
        "telephone": "02-24652141",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/03",
          "srv_Memo": "週六門診暫停服務",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "地區醫院"
      },
      {
        "name": "祐康藥局",
        "address": "基隆市信義區信一路１１５號１樓",
        "telephone": "02-24279521",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/01/15",
          "srv_Memo": "防疫口罩星期一~星期六早上8點~10點現場排隊售完為止",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "N",
                "tagw": "71",
                "urlYN": "V",
                "hospName": null
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "特約藥局"
      },
      {
        "name": "基隆市立慢性病防治所",
        "address": "基隆市信義區信二路２６６號（１Ｆ）",
        "telephone": "02-24230181",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/04/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "元璞牙醫診所",
        "address": "基隆市信義區深溪路２９號１－４樓",
        "telephone": "02-24663009",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/05/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "62",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "仁恩診所",
        "address": "基隆市信義區東信路６９號",
        "telephone": "02-24656136",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/02",
          "srv_Memo": "端午節看診半天，每星期三15:00至19:00看診，七點以後休診，星期六看診半天，星期日全天休診",
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "基隆市信義區衛生所",
        "address": "基隆市信義區信一路６９號",
        "telephone": "02-24221633",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/03/20",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "61",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "基層醫療單位"
      },
      {
        "name": "衛生福利部基隆醫院",
        "address": "基隆市信義區信二路２６８號",
        "telephone": "02-24292525",
        "map": null,
        "serviceInfo": {
          "srv_Date": "113/06/01",
          "srv_Memo": null,
          "srv_Time": [
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "61",
                "urlYN": "V",
                "hospName": null
              },
              {
                "yn": "Y",
                "tagw": "71",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "62",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "72",
                "urlYN": "V",
                "hospName": ""
              }
            ],
            [
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "N",
                "tagw": "",
                "urlYN": "X",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "63",
                "urlYN": "V",
                "hospName": ""
              },
              {
                "yn": "Y",
                "tagw": "73",
                "urlYN": "V",
                "hospName": ""
              }
            ]
          ]
        },
        "type": "區域醫院"
      }
    ],
  },
]